module.exports = __webpack_public_path__ + "img/cpdos.ba34f9f7.png";